<app-header-monitor></app-header-monitor>
  <div class="main-container">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>

